import { USER_ROLES } from "../../constants";
import {
  FETCH_RETURN_ORDER_LIST,
  RESET_RETURN_ORDER_LIST,
} from "../../constants/action.constants";

const initialState = {
  payload: { limit: 10, total: 0, offset: 0 },
  list: [],
  others: {},
};

const returnOrderListReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_RETURN_ORDER_LIST:
      return {
        list: action.payload.data,
        payload: action.payload.payload,
        others: action.others,
      };
    case RESET_RETURN_ORDER_LIST:
      return initialState;
    default:
      return state;
  }
};

export default returnOrderListReducer;
